import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-folder-link',
    templateUrl: './folder-link.component.html',
    styleUrls: ['./folder-link.component.scss'],
    standalone: false
})
export class FolderLinkComponent {
  @Input() element: any;
  @Input() style: any;
  @Output() folderClick = new EventEmitter<any>();
  constructor() {}

  handleFolderClick($event: MouseEvent, arg1: any) {
    console.log('Clicked', $event, arg1);
    this.folderClick.emit({ $event, arg1 });
  }
}
